exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#pages_maincontent[data-v-330c1684]{\n    padding-top: 20px;\n}\n.error[data-v-330c1684]{\n    color: red;\n    border: 1px solid red;\n    background-color: #fbe9e9;\n    text-align: center;\n}\n.custom-text-size[data-v-330c1684]{\n  font-size: 12pt;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-330c1684","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/calc.vue
// module id = 572
// module chunks = 0